module.exports = require("oidc-client");